"use client";
import CoinHandsIcon from "@/assets/icons/coins-hand.svg";
import { Button } from "@/app/(components)/Basic/Button";
import { useState } from "react";
import useWithCorrectNetwork from "@/shared/hooks/useWithCorrectNetwork";
import { useSuccessModal } from "@/app/(components)/Basic/SuccessModal/context/context";
import { NftSettleReserveModal } from "../../../Nft/NftSettleReserveModal";
import { ReserveAuctionOrder } from "@/api/orders/types";
import { ReserveBidWithNft } from "./types";
import useApprovalPrefetch from "@/web3/contracts/Exchange/actions/useApprovalPrefetch";
import useMe from "@/shared/hooks/useMe";

export interface Props {
  auction: ReserveAuctionOrder;
  bid: ReserveBidWithNft;
  className?: string;
}

const SettleAuctionButton = ({ auction, bid }: Props) => {
  const [isAcceptConfirm, setIsPurchaseComplete] = useState(false);

  const { me } = useMe();

  const { setSuccessData } = useSuccessModal();

  const onSuccess = async () => {
    await setSuccessData({
      item: {
        name: bid.nft!.name,
        media: bid.nft!.thumbnail!,
        mediaHeight: bid.nft!.imageHeight!,
        mediaWidth: bid.nft!.imageWidth!,
        mediaType: bid.nft!.mediaType,
        placeholder: bid.nft!.placeholder,
      },
      title: "Congratulations",
      text:
        me!.address !== auction.seller
          ? "You successfully settled an auction and this NFT is now yours"
          : "You accepted bid",
    });

    onClose();
  };

  const onClose = () => {
    setIsPurchaseComplete(false);
  };

  const checkedPurchaseComplete = useWithCorrectNetwork(() => {
    setIsPurchaseComplete(true);
  });

  useApprovalPrefetch(bid.nftContract);

  return (
    <>
      <Button
        onClick={checkedPurchaseComplete}
        className="-bottom-20 mt-10 lg:mt-0 lg:absolute"
        startIcon={
          <CoinHandsIcon className="w-4 h-4 stroke-endemicGray night:stroke-primary" />
        }
      >
        Settle Auction
      </Button>
      {isAcceptConfirm ? (
        <NftSettleReserveModal
          auction={auction}
          bid={bid}
          onSuccess={onSuccess}
          onClose={onClose}
        />
      ) : null}
    </>
  );
};

export default SettleAuctionButton;
